import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Anchor, AnchorLink} from 'kpc';

var _$tmp0 = {
    'href': 'basic-info-card',
    'title': '基础信息'
};
var _$tmp1 = {
    'href': 'config-info-card',
    'title': '配置信息'
};
var _$tmp2 = {
    'href': 'other-info-card',
    'title': '其他信息'
};
var _$tmp3 = {
    'id': 'basic-info-card'
};
var _$tmp4 = {
    'id': 'config-info-card'
};
var _$tmp5 = {
    'id': 'other-info-card'
};
var _$tmp6 = {
    'id': 'scroll-container1'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Anchor, {
            'value': this.get('activeAnchor'),
            'container': '#scroll-container1',
            'children': [
                _$cc(AnchorLink, _$tmp0),
                _$cc(AnchorLink, _$tmp1),
                _$cc(AnchorLink, _$tmp2)
            ]
        }),
        _$ce(2, 'div', [
            _$ce(2, 'div', [
                _$ce(2, 'h2', '基础信息', 16),
                _$ce(2, 'p', '这是基础信息', 16)
            ], 4, 'section basic-info', _$tmp3),
            _$ce(2, 'div', [
                _$ce(2, 'h2', '配置信息', 16),
                _$ce(2, 'p', '这是配置信息', 16)
            ], 4, 'section config-info', _$tmp4),
            _$ce(2, 'div', [
                _$ce(2, 'h2', '其他信息', 16),
                _$ce(2, 'p', '这是其他信息', 16)
            ], 4, 'section other-info', _$tmp5)
        ], 4, 'scroll-container1', _$tmp6)
    ], 4, 'anchor-demo');
};